<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="company">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}产品
        </div>
        <div class="fr">
<!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
<!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>

                <th>
                  <em class="f-red">*</em>
                  品牌
                </th>
                <td>
                  <el-form-item :rules="[{ required: true, trigger: 'blur' }]">
                    <el-select v-model="company.brandId">
                      <el-option v-for="item in brandOptions" :key="item.value" :label="item.label" :value="item.value"
                                 :disabled="item.disabled">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
<!--                <th>-->
<!--                  <em class="f-red">*</em>-->
<!--                  品牌名称-->
<!--                </th>-->
<!--                <td>-->
<!--                  <el-input type="text" autocomplete="off" v-model="company.brandName" clearable/>-->
<!--                </td>-->
                <th>
                  <em class="f-red">*</em>
                  产品编码
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="company.itemCode" @blur="inspection" clearable/>
                </td>

                <th>
                  <em class="f-red">*</em>
                  产品名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="company.itemName" clearable/>
                </td>
                <th>
                  产品型号
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="company.itemModel" clearable/>
                </td>
                <!-- <th>
                <em class="f-red">*</em>
                父ID
                </th>
              <td>
                <el-form-item  :rules="[{ required: true, trigger: 'blur' }]">
                  <el-select v-model="company.parentId" >
                    <el-option  label="0" :value="0" />
                    <el-option  label="1" :value="1" />
                  </el-select>
                </el-form-item>
              </td>							 -->


              </tr>

              <tr>

                <th>
                  <em class="f-red">*</em>
                  产品类型
                </th>
                <td>
                    <el-form-item :rules="[{ required: true, trigger: 'blur' }]"  class="select_input">
                      <el-select v-model="company.bigCategoryId" placeholder="大类" @change='selectOne'  clearable
                        style="width: 49%!important;">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" >
                        </el-option>
                      </el-select>
                      <el-select v-model="company.smallCategoryId" placeholder="小类" clearable
                      style="width: 49%!important;margin-left:2%;">
                        <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>


                <th>
                  是否结算
                </th>
                <td>
                  <el-form-item :rules="[{ required: true, trigger: 'blur' }]">
                    <el-select v-model="company.isSettle">
                      <el-option label="否" :value="0"/>
                      <el-option label="是" :value="1"/>
                    </el-select>
                  </el-form-item>
                </td>
                <th>
                  <em class="f-red">*</em>
                  启用
                </th>
                <td>
                  <el-form-item :rules="[{ required: true, trigger: 'blur' }]">
                    <el-select v-model="company.usable">
                      <el-option label="禁用" :value="0"/>
                      <el-option label="启用" :value="1"/>
                    </el-select>
                  </el-form-item>
                </td>
                <!-- <th>
                <em class="f-red">*</em>
                状态
                </th>
              <td>
                <el-form-item prop="languageId" :rules="[{ required: true, trigger: 'blur' }]">
                  <el-select v-model="company.stat" >
                    <el-option  label="正常" :value="0" />
                    <el-option  label="禁用" :value="1" />
                  </el-select>
                </el-form-item>
              </td> -->
              </tr>

              <tr></tr>
              <tr>
                <th>创建人</th>
                <td>{{ company.createBy }}</td>
                <th>创建时间</th>
                <td>{{ company.createTime }}</td>
              </tr>
              </tbody>
            </table>

          </div>

          <div class="d-item">
            <div class="title first"><b>补充信息</b></div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  业务机构名称
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="company.orgName" clearable/>
                </td>

                <th>
                  保修期(按月)
                </th>
                <td>
                  <el-input type="num" autocomplete="off" v-model="company.guaranteePeriodMonthes" clearable/>
                </td>
                <th>
                  保养周期(按月)
                </th>
                <td>
                  <el-input type="num" autocomplete="off" v-model="company.serviceIntervalMonthes" clearable/>
                </td>
                <th>
                  是否套餐
                </th>
                <td>
                  <el-select v-model="company.itemType">
                    <el-option label="否" :value="0"/>
                    <el-option label="是" :value="1"/>
                  </el-select>
                </td>
              </tr>


              <tr>
                <th>
                  产品上市时间
                </th>
                <td>
                  <el-date-picker v-model="company.onMarketDate" type="date" placeholder="选择日期">
                  </el-date-picker>
                </td>
                <th>
                  产品退市时间
                </th>
                <td>
                  <el-date-picker v-model="company.offMarketDate" type="date" placeholder="选择日期">
                  </el-date-picker>
                </td>
                <th>
                  产品类型
                </th>
                <td>
                  <el-select v-model="company.itemMold">
                    <el-option label="主机" :value="1"/>
                    <el-option label="附件" :value="2"/>
                    <el-option label="其他" :value="9"/>
                  </el-select>
                </td>
                <th>
                  渠道类型
                </th>
                <td>
                  <el-select v-model="company.channelType">
                    <el-option label="线上" :value="1"/>
                    <el-option label="线下" :value="2"/>
                    <el-option label="商业渠道" :value="3"/>
                    <el-option label="其他" :value="9"/>
                  </el-select>

                </td>
              </tr>

              <tr>
                <th>产品图片</th>
                <td colspan="7">
                  <div class="form_picture">
                    <el-upload style="display:flex" :class="{hide_box: upload_btn}" :action="api.uploadFileUrl"
                               ref="upload" accept=".jpeg,.jpg,.png" :headers="headers"
                               :on-remove="handleRemove" list-type="picture-card" :file-list="picList"
                               :on-success="(res,file, fileList) => {handleSuccess(res,file, fileList)}"
                               :on-change="(files, fileList) => {handleChange(files, fileList)}">
                      <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                  </div>

                </td>
              </tr>

              </tbody>
            </table>

          </div>
        </div>

      </div>
    </el-form>
    <productCategoryDialog v-if="showProductCategoryDialog" :visiable.sync="showProductCategoryDialog" multi="false"
                           @confirm="confirmCategory"/>
  </div>
</template>
<script>
import {
  initVxeTable
} from '@/const/crud/admin/table';
import Tinymce from '@/components/Tinymce';
import {
  fetchTree
} from "@/api/admin/type_tree";
import request from "@/router/axios";
import pager from '@/components/pager/index.vue';
import store from "@/store";
// 城市三级联动
import {
  regionData,
  CodeToText,
  TextToCode
} from "element-china-area-data";
import api from "@/api/projectApi";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";

export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    Tinymce,
    pager
  },
  data() {
    return {
      options: [],
      options1: [{}],
      value: '',
      value2: '',
      tempList: [],
      // 以上大小ID  类型信息
      idName: [],
      upload_btn: false, // 是否隐藏上传图片按钮
      activeName: 'first',
      dialog: {
        one: false,
      },
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      // 基本信息
      company: {
        isSettle: 1,
        usable: 1,
        brandId: null,
        brandName: '',
        itemCode: '',
        itemName: '',
        bigCategoryId: '',
        smallCategoryId: '',
        pic: null,
        itemType: 0,
        itemMold: 1,
        guaranteePeriodMonthes: 0,
        serviceIntervalMonthes: 0,
        channelType: null
      },
      picList: [],
      tree: {
        categoryName: '',
        categoryCode: "",
        parentId: "",
        categoryType: 1,
        usable: 1
      },
      brandOptions: [],

      showProductCategoryDialog: false,
      languageDTOs: [],
      upload_img: [],
      dialogImageUrl: '',
    };
  },
  watch: {
    'company.brandId': {
      handler(newVal, oldVal) {
        this.brandOptions.forEach(item => {
          if (newVal === item.value) {
            this.company.brandName = item.label
          }
        })
      },
      deep: true
    },
    picList: {
      handler(newVal, oldVal) {
        this.company.pic = uploadFileFormat(newVal)
      }, deep: true
    }
  },
  computed: {
    api() {
      return api
    },
    // enabled: {}
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId ? tenantId : '1'
      };
    }
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    // console.log(this.company,"tenant的值");
    this.init();
  },
  mounted() {
    this.loadBrandOption()
    this.getData();
    // this.getBrandID();
    console.log(this.company, "company的值");
    console.log(this._dataId, "_dataId的值");
  },
  methods: {
    inspection() {
      if (this.company.itemCode) {
        this.$http({
          url: api.basItem.inspectionUrl,
          method: 'post',
          data: {
            value: this.company.itemCode,
            id: this.company.id,
          }
        }).then(res => {
          if (!res.data.data) {
            this.$message.warning("产品编码已存在，请重新输入")
            this.company.itemCode = null
          }
        })
      }
    },

    // 加载品牌
    loadBrandOption() {
      this.$http({
        url: api.snCompanyBrand.getBrandListUrl,
        method: 'post',
        data: {
          usable: 1  // 加载启用的
        }
      }).then(res => {
        this.brandOptions = []
        res.data.data.forEach(item => {
          this.brandOptions.push({
            label: item.brandName,
            value: item.id
          })
        })
      })
    },

    // 加载页面
    resetEvent() {
      this.$emit('resetEvent')
    },
    // 大小类型
    selectOne() {
      this.company.smallCategoryId = null;
      this.init1()
    },

    // 上传成功
    handleSuccess(res, file, fileList) {
      // 上传成功后，隐藏上传按钮
      this.upload_btn = true;
      console.log(res.data.url, "url")
      this.picList = echoFileFormat(res.data.url)
    },
    handleRemove(response, file, fileList) {
      // 删除成功后，显示上传按钮
      this.upload_btn = false;
      this.picList = []
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 以上表单事件
    confirmSaleConfig(rows) {
      if (rows.length > 0) {
        const $grid = this.$refs.configGrid;
        const tableData3 = $grid.getTableData().fullData;
        const map = {};
        tableData.forEach(function (item) {
          map[item.configId] = 1;
        });
        var items = [];
        rows.forEach((row, index) => {
          const item = {
            configId: row.id,
            configName: row.configName
          };
          if (index == 0 && tableData3.length == 0) {
            item.defaults = true;
          }
          if (!map[item.configId]) {
            items.push(item);
          }
        });
        this.product.saleProductConfigDTOs = this.product.saleProductConfigDTOs.concat(items);
      }
    },
    // 上传成功

    // 第一个  表格
    formatter(row, column) {
      return row.address;
    },
    submitUpload() {
      this.$refs.upload.submit()
    },
    // getBrandID() {
    //   request({
    //     url: '/basic/snCompanyBrand/getBrandList',
    //     method: 'post',
    //     data: this.brandID,
    //     isLoading: true,
    //     modalStrictly: true,
    //   }).then(response => {
    //     console.log(response.data.data.records, "response---this.bran");
    //     let brand = response.data.data.records;
    //     this.brand = brand.map(item => ({
    //       label: item.brandName,
    //       value: item.id,
    //       // id:item.id
    //     }))
    //     // this.brand =response.data.data.records
    //     // response.data.data.records.forEach(item => {
    //     //   this.brand.push({
    //     //     label: item.brandName,
    //     //     value: item.companyId
    //     //   })
    //     // })
    //
    //     console.log(this.brand, "this.bran赋值后");
    //     // this.init1();
    //
    //   })
    //
    // },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        request({
          url: '/basic/basItem/get',
          method: 'post',
          data: {
            id: this._dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.company = response.data.data;
          console.log(this.company, "this.company赋值后");
          this.init1();
          if (this.company.pic != null) {
            this.picList = echoFileFormat(this.company.pic)
          }

        })
      } else {
        // this.enabled = true;
      }
    },
    // 加载大类
    init(_node, _data, _name) {
      fetchTree(this.tree).then(response => {
        this.options = []
        response.data.data.forEach(item => {
          this.options.push({
            label: item.categoryName,
            value: item.id
          })
        })
      });
    },
    init1() { // 子类选择器加载
      fetchTree({
        categoryName: '',
        categoryCode: "",
        parentId: this.company.bigCategoryId,
        categoryType: 1,
        usable: 1
      }).then(response => {
        this.options1 = []
        response.data.data.forEach(item => {
          this.options1.push({
            label: item.categoryName,
            value: item.id
          })
        })
      });
      console.log(this.options1, "this.options1的值");
    },
    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            var url = (this.isEdit ? `/basic/basItem/update` : `/basic/basItem/save`);
            this.$http({
              url: url,
              method: `post`,
              data: this.company,
              isLoading: true,
            }).then(() => {
              // this.resetEvent();
              this.$message.success("保存成功！");
              this.reload()
            }).catch(() => {
              this.$message.error("保存失败！");
            });
            ;
          });
        }

      });
// this.$refs['table-m1'].commitProxy('reload');
    },

    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
  },
};

</script>
<style lang="scss" scoped>
// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

// 输入框的宽度
#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

</style>
